import {
  useCreateSponsorshipMutation,
  useDeleteSponsorshipMutation,
  useDeleteUnactiveSponsorshipsMutation,
  useDownloadSponsorshipsMutation,
  useDownloadSponsorshipsTemplateMutation,
  useGetStudentsSponsorshipsMutation,
  useUpdateSponsorshipsMutation,
  useUploadSponsorshipsMutation,
} from "src/services/sponsorshipsServices";
import {
  LargeHeadingStyled,
  SectionHeaderStyled,
} from "../../../components/custom/texts/texts.styled";
import {
  Button,
  Card,
  Drawer,
  Dropdown,
  Form,
  IUploadProps,
  Icon,
  Select,
} from "@nubeteck/components";
import { DatePicker, Input, InputNumber, Layout, Modal, Table, Upload, Skeleton } from "antd";
import { ColumnsType } from "antd/es/table";
import React, { useEffect, useMemo } from "react";
import toast from "react-hot-toast";
import {
  toastErrorStyle,
  useSuccessSponsorshipUpdatedToast,
  useSuccessSponsorshipsRemovedToast,
  useSuccessSponsorshipsUploadedToast,
} from "src/constants";
import {
  useGetCurrenciesQuery,
  useGetSponsorshipsQuery,
  useGetSponsorshipsTypesQuery,
  useGetStudentsMutation,
} from "src/services";
import { ICurrency, ISponsorship, ISponsorshipTypes } from "@/Interfaces/options";
import { ArrayUtils, FormatterUtils } from "@nubeteck/utils";
import { FlexStyled } from "src/components/registration/register-introduction/register-introduction.styled";
import { downloadExcelBase64, getFormData } from "src/utils/files-util";
import { IPatrocinio } from "src/Interfaces/sponsorship";
import { useGetCareersWithCodeByStudentIdMutation } from "src/services/importsService";
import { useMediaQuery } from "src/hooks";
import { useNavigate } from "react-router-dom";
import { ColumnContainer } from "src/components/layout/main-layout/main-layout.styled";
import dayjs from "dayjs";
import weekday from "dayjs/plugin/weekday";
import { getSponsorAutoservicePage } from "../../../Api/content";
import { useLocale } from "../../../i18n/localeContext";
import { _translateValue } from "../translation-gestor/translateValue";

dayjs.extend(weekday);

const { Content } = Layout;
const SCREEN_NAME = "PantallaSponsorships";

const Sponsorships: React.FC = () => {
  const [form] = Form.useForm<IPatrocinio>();
  const { locale } = useLocale();
  const [sponsorAutoservicePage, setSponsorAutoservicePage] = React.useState<any>(null);
  const [isLoadingContent, setIsLoadingContent] = React.useState<boolean>(true);
  const showSuccessSponsorshipUpdatedToast = useSuccessSponsorshipUpdatedToast();
  const showSuccessSponsorshipsRemovedToast = useSuccessSponsorshipsRemovedToast();
  const showSuccessSponsorshipsUploadedToast = useSuccessSponsorshipsUploadedToast();

  const [pageNumber, setPageNumber] = React.useState(1);
  const [rowsCount, setRowsCount] = React.useState(5);
  const [studentName, setStudentName] = React.useState("");
  const [studentNameForm, setStudentNameForm] = React.useState("");
  const [sponsorshipName, setSponsorshipName] = React.useState("");
  const [filtroUsado, setFiltroUsado] = React.useState(null);
  const [startDate, setStartDate] = React.useState<string | null>(null);
  const [endDate, setEndDate] = React.useState<string | null>(null);
  const [patrocinioId, setPatrocinioId] = React.useState(0);
  const [drawerOpen, setDrawerOpen] = React.useState(false);
  const isMobile = useMediaQuery("(max-inline-size: 1180px)");
  const [modal, contextHolder] = Modal.useModal();
  const [translatedData, setTranslatedData] = React.useState<{
    patrocinios: { [key: string]: string };
    tipos: { [key: string]: string };
    monedas: { [key: string]: string };
    estados: { [key: string]: string };
    usados: { [key: string]: string };
  }>({
    patrocinios: {},
    tipos: {},
    monedas: {},
    estados: {},
    usados: {},
  });

  const [getCareersByStudentId, { isLoading: isLoadingCareers, data: dataCareers }] =
    useGetCareersWithCodeByStudentIdMutation();
  const [getSponsorships, { data, isLoading }] = useGetStudentsSponsorshipsMutation();
  const [
    uploadSponsorships,
    { isSuccess: isSuccessUpload, isLoading: isLoadingUpload, error: errorUpload },
  ] = useUploadSponsorshipsMutation();
  const [
    downloadSponsorshipsTemplate,
    { isLoading: isLoadingDownloadTemplate, data: downloadTemplate },
  ] = useDownloadSponsorshipsTemplateMutation();
  const [downloadSponsorships, { isLoading: isLoadingDownload, data: download }] =
    useDownloadSponsorshipsMutation();
  const [
    updateSponsorship,
    { isLoading: isLoadingUpdate, isSuccess: isSuccessUpdate, error: errorUpdate },
  ] = useUpdateSponsorshipsMutation();
  const [
    createSponsorship,
    { isLoading: isLoadingCreate, isSuccess: isSuccessCreate, error: errorCreate },
  ] = useCreateSponsorshipMutation();
  const [
    deleteSponsorship,
    { isLoading: isLoadingDelete, isSuccess: isSuccessDelete, error: errorDelete },
  ] = useDeleteSponsorshipMutation();
  const [
    deleteUnactiveSponsorships,
    {
      isLoading: isLoadingDeleteUnactive,
      isSuccess: isSuccessDeleteUnactive,
      error: errorDeleteUnactive,
    },
  ] = useDeleteUnactiveSponsorshipsMutation();

  const { data: sponsorships } = useGetSponsorshipsQuery("");
  const { data: sponsorshipsTypes } = useGetSponsorshipsTypesQuery("");
  const [getStudents, { data: students, isLoading: isLoadingStudents }] = useGetStudentsMutation();
  const { data: currencies } = useGetCurrenciesQuery("");

  const carrerasOptions = ArrayUtils.selectLabelValue(dataCareers?.data ?? [], "opcion", "opcion");

  useEffect(() => {
    let cancel = false;
    setIsLoadingContent(true);
    getSponsorAutoservicePage(locale)
      .then((res) => {
        const data = res?.data?.attributes || res?.data || res;
        if (!cancel) {
          setSponsorAutoservicePage(data);
          setIsLoadingContent(false);
        }
      })
      .catch(() => {
        if (!cancel) {
          setSponsorAutoservicePage(null);
          setIsLoadingContent(false);
        }
      });
    return () => {
      cancel = true;
    };
  }, [locale]);

  const navigate = useNavigate();
  useEffect(() => {
    getSponsorships({
      rowsCount,
      page: pageNumber,
      estudianteNombre: studentName,
      patrocinioNombre: sponsorshipName,
      usado: filtroUsado,
      fechaInicio: startDate,
      fechaFin: endDate,
    });
  }, [
    getSponsorships,
    pageNumber,
    rowsCount,
    studentName,
    endDate,
    startDate,
    sponsorshipName,
    isSuccessCreate,
    isSuccessUpload,
    isSuccessUpdate,
    isSuccessDeleteUnactive,
    isSuccessDelete,
    filtroUsado,
  ]);

  useEffect(() => {
    getStudents({
      rowsCount: 20,
      page: 1,
      estudianteNombre: studentNameForm,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [studentNameForm]);

  // Efecto para traducir los campos traducibles cuando lleguen los datos o cambie el locale
  useEffect(() => {
    const translateData = async () => {
      // Verificar si hay datos para traducir
      const hasData = data?.data?.result && Array.isArray(data.data.result) && data.data.result.length > 0;

      // Si no hay datos, no hacer nada
      if (!hasData) {
        setTranslatedData({
          patrocinios: {},
          tipos: {},
          monedas: {},
          estados: {},
          usados: {},
        });
        return;
      }

      const patrociniosTranslations: { [key: string]: string | null } = {};
      const tiposTranslations: { [key: string]: string | null } = {};
      const monedasTranslations: { [key: string]: string | null } = {};
      const estadosTranslations: { [key: string]: string | null } = {};
      const usadosTranslations: { [key: string]: string | null } = {};

      const translationPromises: Promise<void>[] = [];

      // Recopilar todos los valores únicos que necesitan traducción
      data.data.result.forEach((record: IPatrocinio) => {
        // Traducir patrocinio
        if (record.patrocinioNombre && !patrociniosTranslations.hasOwnProperty(record.patrocinioNombre)) {
          patrociniosTranslations[record.patrocinioNombre] = null; // Marcador para evitar duplicados
          translationPromises.push(
            _translateValue(SCREEN_NAME, record.patrocinioNombre, locale).then((translated) => {
              patrociniosTranslations[record.patrocinioNombre] = translated;
            })
          );
        }

        // Traducir tipo de patrocinio
        const patrocinioTipo = (record as any).patrocinioTipo;
        if (patrocinioTipo && !tiposTranslations.hasOwnProperty(patrocinioTipo)) {
          tiposTranslations[patrocinioTipo] = null; // Marcador para evitar duplicados
          translationPromises.push(
            _translateValue(SCREEN_NAME, patrocinioTipo, locale).then((translated) => {
              tiposTranslations[patrocinioTipo] = translated;
            })
          );
        }

        // Traducir moneda
        if (record.monedaNombre && !monedasTranslations.hasOwnProperty(record.monedaNombre)) {
          monedasTranslations[record.monedaNombre] = null; // Marcador para evitar duplicados
          translationPromises.push(
            _translateValue(SCREEN_NAME, record.monedaNombre, locale).then((translated) => {
              monedasTranslations[record.monedaNombre] = translated;
            })
          );
        }

        // Traducir estado (Activo/Inactivo)
        const estadoText = record.estaActivo ? "Activo" : "Inactivo";
        if (!estadosTranslations.hasOwnProperty(estadoText)) {
          estadosTranslations[estadoText] = null; // Marcador para evitar duplicados
          translationPromises.push(
            _translateValue(SCREEN_NAME, estadoText, locale).then((translated) => {
              estadosTranslations[estadoText] = translated;
            })
          );
        }

        // Traducir usado (Si/No)
        const usadoText = record.usado ? "Si" : "No";
        if (!usadosTranslations.hasOwnProperty(usadoText)) {
          usadosTranslations[usadoText] = null; // Marcador para evitar duplicados
          translationPromises.push(
            _translateValue(SCREEN_NAME, usadoText, locale).then((translated) => {
              usadosTranslations[usadoText] = translated;
            })
          );
        }
      });

      await Promise.all(translationPromises);

      // Actualizar estados con las traducciones
      setTranslatedData({
        patrocinios: patrociniosTranslations as { [key: string]: string },
        tipos: tiposTranslations as { [key: string]: string },
        monedas: monedasTranslations as { [key: string]: string },
        estados: estadosTranslations as { [key: string]: string },
        usados: usadosTranslations as { [key: string]: string },
      });
    };

    translateData();
  }, [data?.data?.result, locale]);

  useEffect(() => {
    if (errorCreate) toast.error(errorCreate?.data?.message, toastErrorStyle);
    if (isSuccessCreate) {
      showSuccessSponsorshipUpdatedToast();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuccessCreate, errorCreate, showSuccessSponsorshipUpdatedToast]);
  useEffect(() => {
    if (errorUpdate) toast.error(errorUpdate?.data?.message, toastErrorStyle);
    if (isSuccessUpdate) {
      showSuccessSponsorshipUpdatedToast();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuccessUpdate, errorUpdate, showSuccessSponsorshipUpdatedToast]);
  useEffect(() => {
    if (errorDelete) toast.error(errorDelete?.data?.message, toastErrorStyle);
    if (isSuccessDelete) {
      showSuccessSponsorshipUpdatedToast();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuccessDelete, errorDelete, showSuccessSponsorshipUpdatedToast]);

  useEffect(() => {
    if (errorDeleteUnactive) toast.error(errorDeleteUnactive?.data?.message, toastErrorStyle);
    if (isSuccessDeleteUnactive) {
      showSuccessSponsorshipsRemovedToast();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuccessDeleteUnactive, errorDeleteUnactive, showSuccessSponsorshipsRemovedToast]);

  useEffect(() => {
    if (errorUpload) {
      toast.error(JSON.parse(errorUpload?.data).message, toastErrorStyle);
    }
    if (isSuccessUpload) {
      showSuccessSponsorshipsUploadedToast();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuccessUpload, errorUpload, showSuccessSponsorshipsUploadedToast]);

  useEffect(() => {
    if (downloadTemplate?.data) {
      downloadExcelBase64("Plantilla patrocinios", downloadTemplate.data);
    }
  }, [downloadTemplate]);
  useEffect(() => {
    if (download?.data) {
      downloadExcelBase64("Patrocinios registrados", download.data);
    }
  }, [download]);

  // useEffect(() => {
  //   if (isSuccessCareersByStudent) {
  //     const recordSeleccionado = data?.data?.result?.find(
  //       (sp: IPatrocinio) => sp.patrocinioId === patrocinioId,
  //     );
  //     form.setFieldValue("carreraCodigo", recordSeleccionado);
  //   }
  // }, [isSuccessCareersByStudent, patrocinioId, data?.data?.result, form]);

  const deleteSponsorships = () => {
    modal.confirm({
      title: `¿Esta seguro(a) de que desea remover los vouchers inactivos, vencidos o totalmente usados?`,
      icon: <Icon name="" color="#FFC53D" />,
      okText: "Remover vouchers",
      onOk: () => {
        deleteUnactiveSponsorships();
      },
      cancelText: "Cancelar",
      style: { insetBlockStart: 200 },
    });
  };

  const onClickEditarPatrocinio = React.useCallback(
    (record: IPatrocinio) => {
      getCareersByStudentId(record.matricula).then(() => {
        setPatrocinioId(record.estudiantePatrocinioId);
        setDrawerOpen(true);
        setStudentNameForm(record.estudianteNombre);

        form.setFieldsValue({
          monto: record.monto,
          estudianteId: record.estudianteId,
          acuerdo: record.acuerdo,
          estudiantePatrocinioId: record.estudiantePatrocinioId,
          porcentaje: record.porcentaje,
          patrocinioId: record.patrocinioId,
          monedaId: record.monedaId,
          periodoId: record.periodoId,
          carreraCodigo: record.carreraCodigo,
          fechaVencimiento: dayjs("31/12/2024", "DD/MM/YYYY"),
          patrocinioTipoId: record.patrocinioTipoId,
        });
      });
    },
    [form, getCareersByStudentId],
  );
  const onClickEstadoPatrocinio = React.useCallback(
    (id: number, estado: boolean) => {
      deleteSponsorship({ id, estado });
    },
    [deleteSponsorship],
  );

  const submit = (values: any) => {
    if (patrocinioId !== 0) {
      delete values.estudianteId;
      updateSponsorship({ ...values, id: patrocinioId });
    } else {
      createSponsorship(values);
    }
  };

  const studentsOptions = useMemo(
    () => ArrayUtils.selectLabelValue(students?.data?.result, "estudianteNombre", "estudianteId"),
    [students?.data?.result],
  );
  // const sponsorshipTypesOptions = useMemo(
  //   () =>
  //     ArrayUtils.selectLabelValue(
  //       sponsorshipsTypes?.data?.result,
  //       "patrocinioTipoId",
  //       "tipoPatrocinioNombre",
  //     ),
  //   [sponsorshipsTypes?.data?.result],
  // );

  const columns: ColumnsType<IPatrocinio> = useMemo(() => [
    {
      title: sponsorAutoservicePage?.sponsor_table?.[0]?.label || "ID",
      dataIndex: "matricula",
      width: 120,
      fixed: isMobile ? undefined : "left",
    },
    {
      title: sponsorAutoservicePage?.sponsor_table?.[1]?.label || "Estudiante",
      dataIndex: "estudianteNombre",
      width: 150,
    },
    {
      title: sponsorAutoservicePage?.sponsor_table?.[2]?.label || "Patrocinio",
      dataIndex: "patrocinioNombre",
      width: 150,
      render: (text: string) => translatedData.patrocinios[text] || text,
    },
    {
      title: sponsorAutoservicePage?.sponsor_table?.[3]?.label || "Tipo de patrocinio",
      dataIndex: "patrocinioTipo",
      width: 150,
      render: (text: string) => translatedData.tipos[text] || text,
    },
    {
      title: sponsorAutoservicePage?.sponsor_table?.[4]?.label || "Carrera",
      dataIndex: "carreraCodigo",
      width: 150,
    },
    {
      title: sponsorAutoservicePage?.sponsor_table?.[5]?.label || "Fecha vencimiento",
      dataIndex: "fechaVencimiento",
      width: 150,
    },
    {
      title: sponsorAutoservicePage?.sponsor_table?.[6]?.label || "No. de acuerdo",
      dataIndex: "acuerdo",
      width: 120,
    },
    {
      title: sponsorAutoservicePage?.sponsor_table?.[7]?.label || "Referencia",
      dataIndex: "referencia",
      width: 150,
    },
    {
      title: sponsorAutoservicePage?.sponsor_table?.[8]?.label || "Monto límite",
      dataIndex: "monto",
      render: (value) => FormatterUtils.number(value.toFixed(2)),
      width: 120,
    },
    {
      title: sponsorAutoservicePage?.sponsor_table?.[9]?.label || "Porcentaje",
      dataIndex: "porcentaje",
      render: (value) => `${value}%`,
      width: 110,
    },
    {
      title: sponsorAutoservicePage?.sponsor_table?.[10]?.label || "Moneda",
      dataIndex: "monedaNombre",
      width: 150,
      render: (text: string) => translatedData.monedas[text] || text,
    },
    {
      title: sponsorAutoservicePage?.sponsor_table?.[11]?.label || "Fecha elegibilidad",
      dataIndex: "fechaElegibilidad",
      width: 120,
    },
    {
      title: sponsorAutoservicePage?.sponsor_table?.[12]?.label || "Estado",
      dataIndex: "estaActivo",
      render: (value: boolean) => {
        const estadoText = value ? "Activo" : "Inactivo";
        return translatedData.estados[estadoText] || estadoText;
      },
      width: 100,
    },
    {
      title: sponsorAutoservicePage?.sponsor_table?.[13]?.label || "Ha sido utilizado",
      dataIndex: "usado",
      render: (value: boolean) => {
        const usadoText = value ? "Si" : "No";
        return translatedData.usados[usadoText] || usadoText;
      },
      width: 100,
    },
    {
      title: sponsorAutoservicePage?.sponsor_table?.[14]?.label || "Fecha uso",
      dataIndex: "fechaUso",
      width: 120,
    },
    {
      title: sponsorAutoservicePage?.sponsor_table?.[15]?.label || "Monto utilizado",
      dataIndex: "montoUtilizado",
      render: (value) => (value > 0 ? FormatterUtils.number(value) : 0),
      width: 100,
    },
      {
        title: "",
        dataIndex: "actions",
        fixed: "right",
        width: 100,
        render: (_, record) => (
          <Dropdown
            overlayClassName="table-dropdown"
            className="cursor-pointer"
            key={record.patrocinioId}
            trigger={["click"]}
            align={{ offset: [-40, 4] }}
            menu={{
              items: [
                record.estaActivo && !record.usado
                  ? {
                      key: "1",
                      label: "Editar",
                      icon: <Icon name="" color="#A7A7A7" />,
                      onClick: () => onClickEditarPatrocinio(record ?? 0),
                    }
                  : null,
                {
                  key: "2",
                  label: record.estaActivo ? (sponsorAutoservicePage?.inactive_button || "Inactivar") : (sponsorAutoservicePage?.active_button || "Activar"),
                  icon: record.estaActivo ? (
                    <Icon name="" color="#A7A7A7" />
                  ) : (
                    <Icon name="" color="#A7A7A7" />
                  ),
                  onClick: () =>
                    onClickEstadoPatrocinio(
                      record.estudiantePatrocinioId,
                      record.estaActivo ? false : true,
                    ),
                },
                {
                  key: "3",
                  label: sponsorAutoservicePage?.detail_button || "Ver detalle",
                  icon: <Icon name="" outlined />,
                  onClick: () => navigate(`/admin/sponsorships/${record.estudiantePatrocinioId}`),
                },
              ],
            }}
          >
            <Icon name="" isTouchable />
          </Dropdown>
        ),
      },
    ], [sponsorAutoservicePage, isMobile, translatedData, onClickEditarPatrocinio, onClickEstadoPatrocinio, navigate]);

  const filterOption = (input: string, option?: { label: string; value: string }) =>
    (option?.label ?? "").toLowerCase().includes(input.toLowerCase());

  const props: IUploadProps = {
    name: "model",
    multiple: false,
    showUploadList: false,
    maxCount: 1,
    beforeUpload: () => false,
    accept: "*",
  };

  const onChangeExcel = (file: any) => {
    const reader = new FileReader();
    reader.onload = () => {
      if (reader.result !== null)
        fetch(reader.result as string).then((res) =>
          res.blob().then((blob) => {
            uploadSponsorships(getFormData({ file: blob }));
          }),
        );
    };
    reader.readAsDataURL(file);
  };

  return (
    <ColumnContainer>
      {isLoadingContent ? (
        <>
          <Skeleton.Input active size="large" style={{ width: 200, marginBottom: 16 }} />
          <Content style={{ marginTop: "16px" }}>
            <SectionHeaderStyled>
              <FlexStyled style={{ flexWrap: isMobile ? "wrap" : undefined }}>
                <Skeleton.Input active size="default" style={{ width: 250, marginRight: 8 }} />
                <Skeleton.Input active size="default" style={{ width: 120, marginRight: 8 }} />
                <Skeleton.Input active size="default" style={{ width: 280, marginRight: 8 }} />
                <Skeleton.Input active size="default" style={{ width: 200 }} />
              </FlexStyled>
            </SectionHeaderStyled>
            <SectionHeaderStyled style={{ alignContent: "end", gap: "5px", paddingBlockEnd: 10 }}>
              <Skeleton.Input active size="default" style={{ width: 200, marginRight: 8 }} />
              <Skeleton.Input active size="default" style={{ width: 200, marginRight: 8 }} />
              <Skeleton.Input active size="default" style={{ width: 150, marginRight: 8 }} />
              <Skeleton.Input active size="default" style={{ width: 150, marginRight: 8 }} />
              <Skeleton.Input active size="default" style={{ width: 150, marginRight: 8 }} />
              <Skeleton.Input active size="default" style={{ width: 150 }} />
            </SectionHeaderStyled>
            <Card bodyStyle={{ padding: 0, inlineSize: "100%" }}>
              <Skeleton active paragraph={{ rows: 8 }} />
            </Card>
          </Content>
        </>
      ) : (
        <>
          <LargeHeadingStyled>
            {sponsorAutoservicePage?.title || "Patrocinios"}
          </LargeHeadingStyled>
          <Content style={{ marginTop: "16px" }}>
            <SectionHeaderStyled>
              <FlexStyled
                style={{
                  flexWrap: isMobile ? "wrap" : undefined,
                  // flexDirection: isMobile ? "column" : "row",
                }}
              >
                <Button
                  title=""
                  type="default"
                  onClick={downloadSponsorshipsTemplate}
                  loading={isLoadingDownloadTemplate}
                >
                  {sponsorAutoservicePage?.download_excel || "Descargar plantilla de excel"}
                </Button>

                <Upload
                  {...props}
                  disabled={isLoadingUpload}
                  onChange={(info) => {
                    const { status } = info.file;
                    if (status !== "uploading") {
                      onChangeExcel(info.file);
                    }
                  }}
                >
                  <Button icon={<Icon name="" size={13} color="#00479B" />}>
                    {sponsorAutoservicePage?.upload_excel || "Subir excel"}
                  </Button>
                </Upload>

                <Button
                  title=""
                  type="default"
                  onClick={deleteSponsorships}
                  loading={isLoadingDeleteUnactive}
                >
                  {sponsorAutoservicePage?.remover_button || "Remover vouchers vencidos/inactivos"}
                </Button>
                <Button
                  title=""
                  type="default"
                  onClick={() => navigate("changes")}
                  loading={isLoadingDeleteUnactive}
                >
                  {sponsorAutoservicePage?.historic_button || "Ver historial de cambios"}
                </Button>
              </FlexStyled>
            </SectionHeaderStyled>
            <SectionHeaderStyled style={{ alignContent: "end", gap: "5px", paddingBlockEnd: 10 }}>
              <Form.Item label={sponsorAutoservicePage?.search_input || "Búsqueda por nombre o id"}>
                <Input
                  type="text"
                  onChange={(e) => setStudentName(e.target.value)}
                  placeholder={sponsorAutoservicePage?.search_input || "Búsqueda por nombre o id"}
                />
              </Form.Item>{" "}
              <Form.Item label={sponsorAutoservicePage?.search_esponsor || "Búsqueda por patrocinio"}>
                <Input
                  type="text"
                  onChange={(e) => setSponsorshipName(e.target.value)}
                  placeholder={sponsorAutoservicePage?.search_esponsor || "Búsqueda por patrocinio"}
                />
              </Form.Item>
              <Form.Item label={sponsorAutoservicePage?.filter || "Filtro por uso"}>
                <Select
                  allowClear
                  defaultValue={null}
                  options={[
                    {
                      label: sponsorAutoservicePage?.select_optionA || "Mostrar todos",
                      value: null,
                    },
                    {
                      label: sponsorAutoservicePage?.select_optionB || "Mostrar utilizados",
                      value: true,
                    },
                    {
                      label: sponsorAutoservicePage?.select_optionC || "Mostrar no utilizados",
                      value: false,
                    },
                  ]}
                  placeholder={sponsorAutoservicePage?.select_option || "Seleccione un filtro"}
                  onChange={(value) => {
                    setFiltroUsado(value);
                  }}
                />
              </Form.Item>
              <Form.Item name="fechaInicio" label={sponsorAutoservicePage?.startdate || "Fecha de inicio"}>
                <DatePicker
                  format={"DD/MM/YYYY"}
                  onChange={(e) => {
                    setStartDate(e ? e.toDate().toISOString() : null);
                  }}
                />
              </Form.Item>
              <Form.Item name="fechaFin" label={sponsorAutoservicePage?.enddate || "Fecha de fin"}>
                <DatePicker
                  format={"DD/MM/YYYY"}
                  onChange={(e) => {
                    setEndDate(e ? e.toDate().toISOString() : null);
                  }}
                />
              </Form.Item>
              <Button
                title=""
                type="primary"
                onClick={() =>
                  downloadSponsorships({
                    usado: filtroUsado,
                    estudianteNombre: studentName,
                    patrocinioNombre: sponsorshipName,
                    fechaInicio: startDate,
                    fechaFin: endDate,
                  })
                }
                loading={isLoadingDownload}
              >
                {sponsorAutoservicePage?.export_button || "Exportar a excel"}
              </Button>
            </SectionHeaderStyled>

            <Card bodyStyle={{ padding: 0, inlineSize: "100%" }}>
              <Table<IPatrocinio>
                loading={
                  isLoading ||
                  isLoadingCreate ||
                  isLoadingUpdate ||
                  isLoadingDelete ||
                  isLoadingUpload ||
                  isLoadingDeleteUnactive
                }
                columns={columns}
                dataSource={data?.data?.result}
                rowKey={(v) => `${v.estudiantePatrocinioId} ${v.patrocinioNombre}`}
                pagination={{
                  onChange(page, pageSize) {
                    setPageNumber(page);
                    setRowsCount(pageSize);
                  },
                  pageSize: rowsCount,
                  current: pageNumber,
                  total: data?.data?.pageCount * rowsCount,
                  showSizeChanger: true,
                  style: { marginInlineEnd: "30px" },
                }}
                scroll={{ x: 300 }}
              />
              <Drawer
                title={patrocinioId !== 0 ? "Cambiar patrocino a estudiante" : "Asignar patrocinio"}
                placement="right"
                open={drawerOpen}
                onClose={() => {
                  setPatrocinioId(0);
                  setDrawerOpen(false);
                }}
              >
                {" "}
                <Form
                  form={form}
                  layout="vertical"
                  onFinish={(data) => submit(data)}
                  style={{ display: "flex", flexDirection: "column", gap: 16 }}
                >
                  <Form.Item
                    name="estudianteId"
                    label="Estudiante"
                    rules={[
                      {
                        required: true,
                        message: "Este campo es requerido",
                      },
                    ]}
                    style={{ marginBottom: 4 }}
                  >
                    <Select
                      filterOption={filterOption}
                      disabled={patrocinioId !== 0}
                      placeholder="Seleccionar estudiante"
                      optionFilterProp="children"
                      size="large"
                      showSearch
                      loading={isLoadingStudents}
                      autoClearSearchValue={false}
                      allowClear={false}
                      onSearch={(e) => setStudentNameForm(e)}
                      options={studentsOptions}
                    />
                  </Form.Item>
                  <Form.Item
                    name="carreraCodigo"
                    label="Carrera"
                    hasFeedback
                    rules={[
                      {
                        required: true,
                        message: "Este campo es requerido",
                      },
                    ]}
                  >
                    <Select
                      size="large"
                      allowClear
                      options={carrerasOptions}
                      loading={isLoadingCareers}
                      placeholder="Carrera"
                    />
                  </Form.Item>
                  <Form.Item
                    name="fechaVencimiento"
                    label="Fecha vencimiento"
                    hasFeedback
                    rules={[
                      {
                        required: true,
                        message: "Este campo es requerido",
                      },
                    ]}
                  >
                    <DatePicker
                      placeholder="Seleccione la fecha de vencimiento"
                      format={"DD/MM/YYYY"}
                    />
                  </Form.Item>
                  <Form.Item
                    name="patrocinioTipoId"
                    label="Tipo de patrocinio"
                    rules={[
                      {
                        required: true,
                        message: "Este campo es requerido",
                      },
                    ]}
                    style={{ marginBottom: 4 }}
                  >
                    <Select
                      allowClear
                      placeholder="Seleccionar tipo de patrocinio"
                      size="large"
                      options={sponsorshipsTypes?.data?.map((pat: ISponsorshipTypes) => ({
                        label: pat.tipoPatrocinioNombre,
                        value: pat.patrocinioTipoId,
                      }))}
                    />
                  </Form.Item>
                  <Form.Item
                    name="patrocinioId"
                    label="Patrocinio"
                    rules={[
                      {
                        required: true,
                        message: "Este campo es requerido",
                      },
                    ]}
                    style={{ marginBottom: 4 }}
                  >
                    <Select
                      allowClear
                      placeholder="Seleccionar patrocinio"
                      size="large"
                      options={sponsorships?.data?.map((pat: ISponsorship) => ({
                        label: pat.patrocinioNombre,
                        value: pat.patrocinioId,
                      }))}
                    />
                  </Form.Item>
                  <Form.Item
                    name="monedaId"
                    label="Moneda"
                    rules={[
                      {
                        required: true,
                        message: "Este campo es requerido",
                      },
                    ]}
                    style={{ marginBottom: 4 }}
                  >
                    <Select
                      allowClear
                      placeholder="Seleccionar moneda"
                      size="large"
                      options={currencies?.data?.map((ent: ICurrency) => ({
                        label: ent.monedaNombre,
                        value: ent.monedaId,
                      }))}
                    />
                  </Form.Item>
                  <Form.Item
                    name="acuerdo"
                    label="No. de acuerdo"
                    rules={[
                      {
                        required: true,
                        message: "Este campo es requerido",
                      },
                    ]}
                    style={{ marginBottom: 4 }}
                  >
                    <InputNumber size="large" placeholder="No. de acuerdo" min="0" controls={false} />
                  </Form.Item>
                  <FlexStyled>
                    <Form.Item
                      name="monto"
                      label="Monto"
                      rules={[
                        {
                          required: true,
                          message: "Este campo es requerido",
                        },
                      ]}
                      style={{ marginBottom: 4 }}
                    >
                      <InputNumber
                        size="large"
                        placeholder="Monto"
                        min="0"
                        controls={false}
                        formatter={(value) => FormatterUtils.number(value)}
                      />
                    </Form.Item>
                    <Form.Item
                      name="porcentaje"
                      label="Porcentaje"
                      rules={[
                        {
                          required: true,
                          message: "Este campo es requerido",
                        },
                      ]}
                      style={{ marginBottom: 4 }}
                    >
                      <InputNumber
                        size="large"
                        placeholder="Porcentaje"
                        min="0"
                        max="100"
                        controls={false}
                        formatter={(value) => FormatterUtils.percentage(value)}
                      />
                    </Form.Item>
                  </FlexStyled>

                  <Button
                    type="primary"
                    size="large"
                    htmlType="submit"
                    style={{ alignSelf: "flex-end" }}
                    onClick={() => setDrawerOpen(false)}
                  >
                    Aceptar
                  </Button>
                </Form>
              </Drawer>
            </Card>
          </Content>
        </>
      )}
      {contextHolder}
    </ColumnContainer>
  );
};

export default Sponsorships;
